import { useLocalstorageState } from 'rooks';

export const useTheme = () => {
  const [isDarkMode] = useLocalstorageState(`dark-mode`, true);

  if (isDarkMode) {
    document.documentElement.classList.add('dark');
    localStorage.setItem('theme', 'dark');
  } else {
    document.documentElement.classList.remove('dark');
    localStorage.setItem('theme', 'light');
  }
};
